import { fetchDocumentUsageDetails, fetchUsageDetails } from "api/dashboard";

export const SET_USAGE_DETAILS = "actions/dashboard/set-usage-details";
export const SET_DOCUMENT_USAGE_DETAILS = "actions/dashboard/set-document-usage-details";
export const SET_PENDING_DOCUMENTS = "actions/dashboard/set-pending-documents";
export const DASHBOARD_LOADING_STOP = "actions/dashboard/dashboard-loading-stop";

const dispatchFetchUsageDetailsPromise = (accountId, dispatch) => (
  fetchUsageDetails(accountId)
    .then((usageDetails) => {
      dispatch({
        type: SET_USAGE_DETAILS,
        data: { usageDetails }
      });
    })
);

const dispatchFetchDocumentUsageDetailsPromise = (accountId, dispatch) => {
  const urlParams = "limit=1&offset=0&include_total_sum_filtered=true&trashed=false&processing_state=PROCESSED";
  fetchDocumentUsageDetails(accountId, urlParams)
    .then((response) => {
      const totalCount = response.totalCount;
      const totalSumFiltered = response.totalSumFiltered;
      dispatch({
        type: SET_DOCUMENT_USAGE_DETAILS,
        data: { totalCount, totalSumFiltered }
      });
    });
};

const dispatchFetchPendingDocumentsPromise = (accountId, dispatch) => {
  const urlParams =
    "trashed=false&or_processing_state=NEEDS_SYSTEM_PROCESSING&or_processing_state=NEEDS_USER_PROCESSING";
  fetchDocumentUsageDetails(accountId, urlParams)
    .then((response) => {
      const pendingDocumentCount = response.totalCountFiltered;
      dispatch({
        type: SET_PENDING_DOCUMENTS,
        data: { pendingDocumentCount }
      });
    });
};

export const fetchDashboardDetailsAction = (accountId) => (dispatch) => (
  Promise.all([
    dispatchFetchUsageDetailsPromise(accountId, dispatch),
    dispatchFetchDocumentUsageDetailsPromise(accountId, dispatch),
    dispatchFetchPendingDocumentsPromise(accountId, dispatch)
  ])
  .then(() => dispatch({ type: DASHBOARD_LOADING_STOP }))
);



// WEBPACK FOOTER //
// ./src/js/actions/dashboard-actions.js